import { Observable, map } from "rxjs";
import { DeviceScreenSize, IClientPlatform } from '../models/client-platform.model'
import { getKeyValue } from "./type-guards.util";

type WhrOperator = '<' | '<=' | '>' | '>=' | '==' | '!=' | 'contains'
type clientPlatformKey = 'browser.name' | 'browser.version' | 'os.name' | 'os.version' | 'os.versionName' | 'platform.type' | 'platform.vendor' | 'platform.model' | 'engine.name' | 'engine.version' | 'touchPoints';

export const whereClient = (key: clientPlatformKey, operator: WhrOperator, compareTo: number | string | string[]) => {
    return (source: Observable<IClientPlatform>) => {
        return source.pipe(
            map(({browserDetails, isValid}) => {
                if (key === 'touchPoints') {
                    const maxTouchPoints = browserDetails.maxTouchPoints;
                    switch(operator) {
                        case '==':
                            isValid = isValid && (maxTouchPoints === compareTo);
                            break;
                        case '<':
                            isValid = isValid && (maxTouchPoints < compareTo);
                            break;
                        case '<=':
                            isValid = isValid && (maxTouchPoints <= compareTo);
                            break;
                        case '>':
                            isValid = isValid && (maxTouchPoints > compareTo);
                            break;
                        case '>=':
                            isValid = isValid && (maxTouchPoints >= compareTo);
                            break;
                    }
                }
                else {
                    const value = getKeyValue(browserDetails, key); 
                    if (typeof compareTo === 'string') {
                        switch(operator) {
                            case '==':
                                isValid = isValid && compareTo === value;
                                break;
                            case '!=':
                                isValid = isValid && compareTo !== value;
                                break;
                        }
                    }
                    if (Array.isArray(compareTo)) {
                        switch(operator) {
                            case 'contains':
                                isValid = isValid && compareTo.includes(value);
                                break;
                        }
                    }
                }
                return { browserDetails, isValid } as IClientPlatform;
            })
        );
    }
}

export const isiPad = () => {
    return (source: Observable<IClientPlatform>) => {
        return source.pipe(
            whereClient('platform.type','==','desktop'),
            whereClient('os.name','==','macOS'),
            whereClient('touchPoints','>', 0),
        )
    }
}

export const isTabletAndBeyondSize = (minTabletWidth?: number) => {
    return (source: Observable<number>) => {
        return source.pipe(map(innerWidth => innerWidth > 0 && (minTabletWidth ? innerWidth >= minTabletWidth : innerWidth >= DeviceScreenSize.mobile) ? innerWidth : 0))
    }
}

export const isTabletAndBelowSize = (maxTabletWidth?: number) => {
    return (source: Observable<number>) => {
        return source.pipe(map(innerWidth => innerWidth > 0 && (maxTabletWidth ? innerWidth < maxTabletWidth : innerWidth < DeviceScreenSize.mobile) ? innerWidth : 0))
    }
}

export const isMobileSize = (maxMobileWidth?: number) => {
    return (source: Observable<number>) => {
        return source.pipe(map(innerWidth => innerWidth > 0 && (maxMobileWidth ? innerWidth < maxMobileWidth : innerWidth < DeviceScreenSize.mobile) ? innerWidth : 0))
    }
}

export const isTabletSize = (minTabletWidth?: number, maxTablerWidth?: number) => {
    return (source: Observable<number>) => {
        return source.pipe(map(innerWidth => innerWidth > 0 && ((minTabletWidth && maxTablerWidth) ? (innerWidth >= minTabletWidth && innerWidth < maxTablerWidth) : (innerWidth >= DeviceScreenSize.mobile && innerWidth < DeviceScreenSize.tablet)) ? innerWidth : 0))
    }
}

export const isDesktopSize = (minDesktopWidth?: number) => {
    return (source: Observable<number>) => {
        return source.pipe(map(innerWidth => innerWidth > 0 && (minDesktopWidth ? innerWidth >= minDesktopWidth : innerWidth >= DeviceScreenSize.tablet) ? innerWidth : 0))
    }
}

export const isXSSize = () => {
    return (source: Observable<number>) => {
        return source.pipe(map(innerWidth => innerWidth > 0 && innerWidth < DeviceScreenSize.xs ? innerWidth : 0))
    }
}

export const isSSize = () => {
    return (source: Observable<number>) => {
        return source.pipe(map(innerWidth => innerWidth > 0 && (innerWidth >= DeviceScreenSize.xs && innerWidth < DeviceScreenSize.s) ? innerWidth : 0))
    }
}

export const isMSize = () => {
    return (source: Observable<number>) => {
        return source.pipe(map(innerWidth => innerWidth > 0 && (innerWidth >= DeviceScreenSize.s && innerWidth < DeviceScreenSize.md) ? innerWidth : 0))
    }
}

export const isLSize = () => {
    return (source: Observable<number>) => {
        return source.pipe(map(innerWidth => innerWidth > 0 && (innerWidth >= DeviceScreenSize.md && innerWidth < DeviceScreenSize.l) ? innerWidth : 0))
    }
}

export const isXLSize = () => {
    return (source: Observable<number>) => {
        return source.pipe(map(innerWidth => innerWidth > 0 && (innerWidth >= DeviceScreenSize.l && innerWidth < DeviceScreenSize.xl) ? innerWidth : 0))
    }
}

export const isXXLSize = () => {
    return (source: Observable<number>) => {
        return source.pipe(map(innerWidth => innerWidth > 0 && innerWidth >= DeviceScreenSize.xl ? innerWidth : 0))
    }
}